import { serviceApiInstance } from "@/utils/helper";

// Multi-branch config + member-accessible branch list (QTY-1594 BE).
// Both endpoints resolve the member from the Firebase bearer token (attached by
// the axios interceptor) and are exempt from the branch-id header requirement.

export type IsMultiBranchResponse = {
  isMultiBranch: boolean;
};

export const getIsMultiBranch = async (): Promise<IsMultiBranchResponse> => {
  const response = await serviceApiInstance.get<IsMultiBranchResponse>(
    `branches/is-multi-branch`,
  );
  return response.data;
};

// Subset of the BE BranchEntity we actually consume on the member app.
export type MembershipBranch = {
  id: number;
  name: string;
  code: string;
  slug: string;
  isActive: boolean;
};

export const getMembershipBranches = async (): Promise<MembershipBranch[]> => {
  const response = await serviceApiInstance.get<MembershipBranch[]>(
    `me/profile/membership-branches`,
  );
  return response.data;
};
